import { formatDate, formatMoney } from 'helpers/helpers';
import CustomTooltip from 'pages/parts/CustomTooltip';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

function XReport({ xReport, toggleModalExpense }) {
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState(1);
	const [products, setProducts] = useState([]);

	useEffect(() => {
		var products = {
			products: [],
			rolls: [],
			accessories: [],
			shapes: [],
			tunicophones: [],
			totalProducts: 0,
			totalRolls: 0,
			totalAccessories: 0,
			totalShapes: 0,
			totalTunicophones: 0,
			totalProductsQuantity: 0,
			totalRollsQuantity: 0,
			totalAccessoriesQuantity: 0,
			totalShapesQuantity: 0,
			totalTunicophonesQuantity: 0,
		};
		for (let i = 0; i < xReport['products'].length; i++) {
			const product = xReport['products'][i];
			if (product.product_type === 1) {
				products.products.push(product)
				products.totalProducts += Number(product['total_amount']);
				products.totalProductsQuantity += Number(product['total_metr']);
			}
			if (product.product_type === 2) {
				products.rolls.push(product)
				products.totalRolls += Number(product['total_amount']);
				products.totalRollsQuantity += Number(product['total_quantity']);
			}
			if (product.product_type === 3) {
				products.accessories.push(product)
				products.totalAccessories += Number(product['total_amount']);
				products.totalAccessoriesQuantity += Number(product['total_metr']);
			}
			if (product.product_type === 4) {
				products.shapes.push(product)
				products.totalShapes += Number(product['total_amount']);
				products.totalShapesQuantity += Number(product['total_metr']);
			}
			if (product.product_type === 5) {
				products.tunicophones.push(product)
				products.totalTunicophones += Number(product['total_amount']);
				products.totalTunicophonesQuantity += Number(product['total_metr']);
			}
		}
		setProducts(products);
	}, [xReport.products]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="d-flex justify-content-between gap-4">
			<div className="d-flex flex-column fz-14 w-25">
				<div className={`tab ${activeTab === 1 && 'active'}`} onClick={() => setActiveTab(1)}>
					X {t('report')}
				</div>
				<div className={`tab ${activeTab === 2 && 'active'}`} onClick={() => setActiveTab(2)}>
					{t('payment')}
				</div>
				<div className={`tab ${activeTab === 3 && 'active'}`} onClick={() => setActiveTab(3)}>
					{t('categories')}
				</div>
				{/* <div className={`tab ${activeTab === 4 && 'active'}`} onClick={() => setActiveTab(4)}>
								{t('rolls')}
							</div> */}
				<div className={`tab ${activeTab === 5 && 'active'}`} onClick={() => setActiveTab(5)}>
					{t('clients')}
				</div>
				<div className={`tab ${activeTab === 6 && 'active'}`} onClick={() => setActiveTab(6)}>
					{t('debt')}
				</div>
				<div className={`tab ${activeTab === 7 && 'active'}`} onClick={() => setActiveTab(7)}>
					{t('take_money')}
				</div>
				<div className={`tab ${activeTab === 8 && 'active'}`} onClick={() => setActiveTab(8)}>
					{t('put_money')}
				</div>
				<div className={`tab ${activeTab === 9 && 'active'}`} onClick={() => setActiveTab(9)}>
					{t('cheques')}
				</div>
			</div>

			<div className="w-100">
				{activeTab === 1 &&
					<>
						{xReport.opened_shift &&
							<>
								<div className="d-between fw-500">
									<div>{t('shift')} ID</div>
									<div>{xReport.opened_shift.id}</div>
								</div>
								<div className="d-between fw-500">
									<div>{t('cashier')}</div>
									<div>{xReport.opened_shift.cashier_name}</div>
								</div>
								<div className="d-between fw-500">
									<div>{t('opened_date')}</div>
									<div>{formatDate(xReport.opened_shift.opened_at, "dd.MM.yyyy HH:mm")}</div>
								</div>
								<div className="d-between fw-500">
									<div>{t('closed_date')}</div>
									<div>{formatDate(xReport.opened_shift.closed_at)}</div>
								</div>
								<hr />
							</>
						}

						<div className="d-between fw-500">
							<div>{t('cheques')}</div>
							<div>{xReport.total_cheques}</div>
						</div>
						<div>
							<div className="d-between fw-500">
								<div>{t('sales')}</div>
								<div className="text-success">{formatMoney(xReport.total_sales)}</div>
							</div>
							<div className="ps-3">
								{xReport?.payment_types?.map((item, index) => (
									<div className="d-between" key={index}>
										<div>{item.name}</div>
										<div className="text-success">{formatMoney(item.total_amount)}</div>
									</div>
								))
								}
							</div>
						</div>
						<div className="d-between fw-500">
							<div>{t('debt')}</div>
							<div className="text-danger">{formatMoney(xReport.total_clients_debt)}</div>
						</div>
						{Number(xReport.total_returns) > 0 &&
							<div className="d-between fw-500">
								<div>{t('return')}</div>
								<div className="text-danger">{formatMoney(xReport.total_returns)}</div>
							</div>
						}
						<div className="d-between fw-500">
							<div>{t('discount')}</div>
							<div className="text-danger">{formatMoney(xReport.total_discount)}</div>
						</div>

						<hr />

						<div className="d-between fw-500">
							<div>{t('total_checkout')}</div>
							<div className="text-success">{formatMoney(xReport.total_checkout)}</div>
						</div>

						<div className="ps-3">
							{xReport?.checkout_payment_types?.map((item, index) => (
								<div className="d-between" key={index}>
									{item.name} {item.is_usd && ` [ ${formatMoney(item.total_amount_usd)} ] `}
									<div className="text-success">
										{formatMoney(item.total_amount)}
									</div>
								</div>
							))
							}
						</div>

						{xReport?.incomes?.length > 0 &&
							<div>
								<div className="d-between fw-500">
									<div>{t('income')}</div>
									<div className="text-success">{formatMoney(xReport.total_incomes)}</div>
								</div>
								<div className="ps-3">
									{xReport?.incomes?.map((item, index) => (
										item.payment_type_name &&
										<div className="d-between" key={index}>
											<div>{item.payment_type_name} {item.name}</div>
											<div className="text-success">{formatMoney(item.total_amount)}</div>
										</div>
									))
									}
								</div>
							</div>
						}

						{xReport?.expenses?.length > 0 &&
							<div>
								<div className="d-between fw-500">
									<div>{t('expense')}</div>
									<div className="text-danger">{formatMoney(xReport.total_expenses)}</div>
								</div>
								<div className="ps-3">
									{xReport?.expenses?.map((item, index) => (
										item.payment_type_name &&
										<div className="d-between" key={index}>
											<div>{item.payment_type_name} {item.name}</div>
											<div className="text-danger">{formatMoney(item.total_amount)}</div>
										</div>
									))
									}
								</div>
							</div>
						}

						{/* <div className="d-between">
										<div>{t('income')}</div>
										<div className="text-success">{formatMoney(xReport.total_incomes)}</div>
									</div>
									<div className="d-between">
										<div>{t('expense')}</div>
										<div className="text-danger">{formatMoney(xReport.total_expenses)}</div>
									</div> */}
						<div className="d-between fw-500">
							<div>{t('cashbox_balance')}</div>
							<div className="text-success">{formatMoney(xReport.cashbox_balance)}</div>
						</div>
					</>
				}

				{activeTab === 2 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{t('name2')}</th>
									<th className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.payment_types?.map((item, index) => (
									<tr key={index}>
										<td>{item.name} {item.is_usd && ` [ ${formatMoney(item.total_amount_usd)} ] `}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(xReport.total_payment_types_amount)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}

				{activeTab === 3 &&
					<>
						{products?.accessories?.length > 0 &&
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: '50%' }}>{t('accessory')}</th>
										<th style={{ width: '20%' }} className="text-end">{t('metr')}</th>
										<th style={{ width: '30%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{products?.accessories?.map((item, index) => (
										<tr key={index}>
											<td>{item.name}</td>
											<td className="text-end">{item.total_metr}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td className="text-end">{formatMoney(products.totalAccessoriesQuantity)}</td>
										<td className="text-end">{formatMoney(products.totalAccessories)}</td>
									</tr>
								</tbody>
							</table>
						}
						{products.tunicophones?.length > 0 &&
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: '50%' }}>{t('tunikofon')}</th>
										<th style={{ width: '20%' }} className="text-end">{t('metr')}</th>
										<th style={{ width: '30%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{products?.tunicophones?.map((item, index) => (
										<tr key={index}>
											<td>{item.name}</td>
											<td className="text-end">{item.total_metr}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td className="text-end">{formatMoney(products.totalTunicophonesQuantity)}</td>
										<td className="text-end">{formatMoney(products.totalTunicophones)}</td>
									</tr>
								</tbody>
							</table>
						}
						{products?.shapes?.length > 0 &&
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: '50%' }}>{t('profiled_sheeting')}</th>
										<th style={{ width: '20%' }} className="text-end">{t('metr')}</th>
										<th style={{ width: '30%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{products?.shapes?.map((item, index) => (
										<tr key={index}>
											<td>{item.name}</td>
											<td className="text-end">{item.total_metr}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td className="text-end">{formatMoney(products.totalShapesQuantity)}</td>
										<td className="text-end">{formatMoney(products.totalShapes)}</td>
									</tr>
								</tbody>
							</table>
						}
						{products?.rolls?.length > 0 &&
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: '50%' }}>{t('roll')}</th>
										<th style={{ width: '20%' }} className="text-end">{t('quantity')}</th>
										<th style={{ width: '30%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{products?.rolls?.map((item, index) => (
										<tr key={index}>
											<td>{item.name}</td>
											<td className="text-end">{item.total_quantity}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td className="text-end">{formatMoney(products.totalRollsQuantity)}</td>
										<td className="text-end">{formatMoney(products.totalRolls)}</td>
									</tr>
								</tbody>
							</table>
						}
						{products?.products?.length > 0 &&
							<table className="table table-bordered">
								<thead>
									<tr>
										<th style={{ width: '50%' }}>{t('product')}</th>
										<th style={{ width: '20%' }} className="text-end">{t('quantity')}</th>
										<th style={{ width: '30%' }} className="text-end">{t('amount')}</th>
									</tr>
								</thead>
								<tbody>
									{products?.products?.map((item, index) => (
										<tr key={index}>
											<td>{item.name}</td>
											<td className="text-end">{item.total_quantity}</td>
											<td className="text-end">{formatMoney(item.total_amount)}</td>
										</tr>
									))
									}
									<tr className="tr-bold">
										<td>{t('total')}</td>
										<td className="text-end">{formatMoney(products.totalProductsQuantity)}</td>
										<td className="text-end">{formatMoney(products.totalProducts)}</td>
									</tr>
								</tbody>
							</table>
						}
					</>
				}

				{/* {activeTab === 4 &&
								<>
									<table className="table table-bordered">
										<thead>
											<tr>
												<th>{t('name2')}</th>
												<th className="text-end">{t('quantity')}</th>
												<th className="text-end">{t('amount')}</th>
											</tr>
										</thead>
										<tbody>
											{xReport?.elements?.map((item, index) => (
												<tr key={index}>
													<td>{item.name}</td>
													<td className="text-end">{item.total_quantity}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))
											}
											<tr className="tr-bold">
												<td>{t('total')}</td>
												<td></td>
												<td className="text-end">{formatMoney(xReport.total_elements_amount)}</td>
											</tr>
										</tbody>
									</table>
								</>
							} */}

				{activeTab === 5 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{t('name2')}</th>
									<th className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.clients?.map((item, index) => (
									<tr key={index}>
										<td>{item.name}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(xReport.total_clients_amount)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}

				{activeTab === 6 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{t('name2')}</th>
									<th className="text-end">{t('total_debt')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.clients_debt?.map((item, index) => (
									<tr key={index}>
										<td>{item.name}</td>
										<td className="text-end">{formatMoney(item.total_debt)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(xReport.total_clients_debt)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}

				{activeTab === 7 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{t('type')}</th>
									{/* <th>{t('counterparty')}</th> */}
									<th>{t('note')}</th>
									<th className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.expenses?.map((item, index) => (
									<tr key={index}>
										{toggleModalExpense ?
											<td className="text-primary cursor" onClick={() => toggleModalExpense(true, 'table', item.payment_purpose_id)}>
												{item.name}
											</td>
											:
											<td>
												{item.name}
											</td>
										}
										{/* <td>{item.counterparty}</td> */}
										<td>{item.note}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									{/* <td></td> */}
									<td></td>
									<td className="text-end">{formatMoney(xReport.total_expenses)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}

				{activeTab === 8 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{t('type')}</th>
									{/* <th>{t('counterparty')}</th> */}
									<th>{t('note')}</th>
									<th className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.incomes?.map((item, index) => (
									<tr key={index}>
										{toggleModalExpense ?
											<td className="text-primary cursor" onClick={() => toggleModalExpense(true, 'table', item.payment_purpose_id)}>
												{item.name}
											</td>
											:
											<td>
												{item.name}
											</td>
										}
										{/* <td>{item.counterparty}</td> */}
										<td>{item.note}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									{/* <td></td> */}
									<td></td>
									<td className="text-end">{formatMoney(xReport.total_incomes)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}

				{activeTab === 9 &&
					<>
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ minWidth: '33px' }}>{t('id')}</th>
									<th style={{ width: '50%' }} className="td-ellipsis">{t('cashier')}</th>
									<th style={{ width: '50%' }} className="td-ellipsis">{t('client')}</th>
									<th style={{ minWidth: '130px' }} className="text-center">{t('open_date')}</th>
									<th style={{ minWidth: '130px' }} className="text-center">{t('close_date')}</th>
									<th style={{ minWidth: '100px' }} className="text-end">{t('paid')}</th>
									<th style={{ minWidth: '100px' }} className="text-end">{t('not_paid')}</th>
									<th style={{ minWidth: '100px' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{xReport?.cheques?.map((item, index) => (
									<tr key={index}>
										<td>{item.id}</td>
										<td className="td-ellipsis">
											<CustomTooltip text={item.cashier_name}>
												{item.cashier_name}
											</CustomTooltip>
										</td>
										<td className="td-ellipsis">
											<CustomTooltip text={item.client_name}>
												{item.client_name}
											</CustomTooltip>
										</td>
										<td className="text-center">{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-center">{formatDate(item.cheque_closed_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-end">{formatMoney(item.paid)}</td>
										<td className="text-end">{formatMoney(item.total_amount - item.paid)}</td>
										<td className="text-end">{formatMoney(item.total_amount)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									{/* <td></td> */}
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end">{formatMoney(xReport.total_cheques_paid)}</td>
									<td className="text-end">{formatMoney(xReport.total_cheques_amount - xReport.total_cheques_paid)}</td>
									<td className="text-end">{formatMoney(xReport.total_cheques_amount)}</td>
								</tr>
							</tbody>
						</table>
					</>
				}
			</div>

		</div>

	)
}

export default XReport